export const MODIFIERS = ['Alt', 'Control', 'Meta', 'Shift'];
